import { FormEvent, useState } from "react";
import { useAppSelector } from "../../../app/store/store";
import { IStudent, studentService } from "../../../entities/student";
import { MyButton } from "../../../shared/ui/button";
import { MyInput } from "../../../shared/ui/input";
import classes from "./paymentLandingWidget.module.scss";
import idmClasses from "../../idm/ui/idm/idmWidget.module.scss";
import { Link } from "react-router-dom";
import tbankLogo from "../../../shared/lib/assets/tbank.png";
import alphaLogo from "../../../shared/lib/assets/alpha.png";
import tochkaLogo from "../../../shared/lib/assets/tochka.png";
import { FEATURES, FEATURE_SECTIONS, hasFeature } from "../../../entities/my";
import { MyError } from "../../../shared/lib/error/MyError";

export const PaymentLandingWidget = () => {

    const {my} = useAppSelector(s => s.myReducer)
    const [url, setUrl] = useState('')
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [student, setStudent] = useState<IStudent | null>(null)

    const isPaymentLandingAccess = hasFeature(my, FEATURES.FRONT.PAYMENT_LANDING);
    const canOpenStudentCard = student?.user_id
        ? hasFeature(my, FEATURE_SECTIONS.STUDENTS)
            && hasFeature(my, FEATURES.STUDENTS.CARD_READ, student.user_id)
        : false

    const getPaymentLogo = (paymentName: string) => {
        const normalizedPaymentName = paymentName.trim().toLowerCase()

        if(
            normalizedPaymentName.includes('т-банк')
            || normalizedPaymentName.includes('тбанк')
            || normalizedPaymentName.includes('тиньк')
            || normalizedPaymentName.includes('tbank')
        ){
            return {src: tbankLogo, alt: 'Т-Банк'}
        }

        if(
            normalizedPaymentName.includes('альфа')
            || normalizedPaymentName.includes('alpha')
        ){
            return {src: alphaLogo, alt: 'Альфа'}
        }

        if(
            normalizedPaymentName.includes('точка')
            || normalizedPaymentName.includes('tochka')
        ){
            return {src: tochkaLogo, alt: 'Точка'}
        }

        return null
    }

    const onChangeUrl = (value: string) => {
        setUrl(value)
        setStudent(null)
    }

    const onSubmit = async (e?: FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        const trimmedUrl = url.trim()

        if(!trimmedUrl){
            setError('Введите ссылку')
            setStudent(null)
            return
        }

        try{
            setIsLoading(true)
            setError('')
            const currentStudent = await studentService.getByPaymentUrl(trimmedUrl)
            setStudent({
                id: currentStudent.id,
                user_id: currentStudent.user_id,
                first_name: currentStudent.first_name,
                last_name: currentStudent.last_name,
                middle_name: currentStudent.middle_name,
                tg: currentStudent.tg ?? '',
                parent_full_name: currentStudent.parent_full_name ?? '',
                is_only_trial_finished: currentStudent.is_only_trial_finished ?? false,
                is_balance_negative: currentStudent.is_balance_negative ?? false,
                is_newbie: currentStudent.is_newbie ?? false,
                balance: currentStudent.balance ?? '',
                payment_name: currentStudent.payment_name ?? '',
                comments_count: currentStudent.comments_count ?? 0,
            })
        }
        catch(e){
            setStudent(null)
            setError(
                e instanceof MyError && e.status === 404
                    ? 'Студент по этой ссылке не найден'
                    : e instanceof Error
                        ? e.message
                        : 'Не удалось получить данные студента'
            )
        }
        finally{
            setIsLoading(false)
        }
    }

    if(!isPaymentLandingAccess){
        return null
    }

    const paymentLogo = student ? getPaymentLogo(student.payment_name || '') : null

    return (
        <section className={classes.widget}>
            <section className={classes.title}>Поиск студента по лендосу</section>
            <form className={classes.form} onSubmit={onSubmit}>
                <section className={classes.input}>
                    <MyInput
                        value={url}
                        setValue={onChangeUrl}
                        placeholder="Вставьте ссылку для проверки"
                        isLoading={isLoading}
                        error={error}
                        setError={setError}
                    />
                </section>
                <section className={classes.button}>
                    <MyButton isLoading={isLoading}>
                        Найти
                    </MyButton>
                </section>
            </form>
            {
                student
                    &&
                <section className={classes.result}>
                    {canOpenStudentCard ? <Link className={classes.nameLink} to={`/students/${student.id}`}>
                        <span className={idmClasses.staffName}>
                            {student.id}. {`${student.last_name} ${student.first_name} ${student.middle_name}`.trim()}
                        </span>
                    </Link> : <span className={idmClasses.staffName}>
                        {student.id}. {`${student.last_name} ${student.first_name} ${student.middle_name}`.trim()}
                    </span>}
                    <section className={classes.infoGrid}>
                        <span className={idmClasses.staffEmail}>
                            Родитель: {student.parent_full_name || 'Не указан'}
                        </span>
                        <span className={idmClasses.staffRoles}>
                            Баланс: {student.balance} ₽
                        </span>
                        <span className={idmClasses.staffRoles}>
                            Платежка:
                            {
                                paymentLogo &&
                                <img
                                    src={paymentLogo.src}
                                    alt={paymentLogo.alt}
                                    className={classes.paymentLogo}
                                />
                            }
                            <span className={classes.paymentName}>{student.payment_name || 'Не указана'}</span>
                        </span>
                        {
                            student.tg?.trim()
                                ?
                            <a
                                target="_blank"
                                rel="noreferrer"
                                className={classes.tgLink}
                                href={student.tg}
                            >
                                Написать в ТГ
                            </a>
                                :
                            <span className={classes.emptyTg}>TG не указан</span>
                        }
                    </section>
                </section>
            }
        </section>
    )
}
